import * as Types from '@Global/apollo/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitBetMutationVariables = Types.Exact<{
  gameId: Types.Scalars['ID']['input'];
  outcomeId: Types.Scalars['ID']['input'];
  amount: Types.Scalars['MoneyAmount']['input'];
  currency: Types.Currency;
}>;


export type SubmitBetMutation = { __typename?: 'Mutation', submitBet?: any | undefined };


export const SubmitBetDocument = gql`
    mutation submitBet($gameId: ID!, $outcomeId: ID!, $amount: MoneyAmount!, $currency: Currency!) {
  submitBet(
    gameId: $gameId
    outcomeId: $outcomeId
    amount: $amount
    currency: $currency
  )
}
    `;
export type SubmitBetMutationFn = Apollo.MutationFunction<SubmitBetMutation, SubmitBetMutationVariables>;

/**
 * __useSubmitBetMutation__
 *
 * To run a mutation, you first call `useSubmitBetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBetMutation, { data, loading, error }] = useSubmitBetMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      outcomeId: // value for 'outcomeId'
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSubmitBetMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBetMutation, SubmitBetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBetMutation, SubmitBetMutationVariables>(SubmitBetDocument, options);
      }
export type SubmitBetMutationHookResult = ReturnType<typeof useSubmitBetMutation>;
export type SubmitBetMutationResult = Apollo.MutationResult<SubmitBetMutation>;
export type SubmitBetMutationOptions = Apollo.BaseMutationOptions<SubmitBetMutation, SubmitBetMutationVariables>;